// import React from "react";
// import { useContext } from "react";
// import { useState } from "react";
// import { FiEye, FiEyeOff } from "react-icons/fi";
// import axios from "axios";

// import Cehr from "../../src/assets/CeHR.png";
// import { Link, useNavigate } from "react-router-dom";
// import { GlobalState } from "../data/Context";
// import { setStoredSession } from "../data/authStorage";

// const Login = () => {
//   const navigate = useNavigate();
//   const { setOrganization } = useContext(GlobalState);
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     setErrorMessage("");

//     if (!email.trim() || !password) {
//       setErrorMessage("Email and password are required");
//       return;
//     }

//     try {
//       setIsSubmitting(true);

//       const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || "").replace(
//         /\/+$/,
//         "",
//       );

//       if (!apiBaseUrl) {
//         throw new Error(
//           "API base URL is not configured. Set REACT_APP_API_BASE_URL.",
//         );
//       }

//       const response = await axios.post(
//         `${apiBaseUrl}/auth/organization/login`,
//         {
//           organizationEmail: email.trim(),
//           password,
//         },
//       );

//       setStoredSession({
//         accessToken: response.data.accessToken,
//         refreshToken: response.data.refreshToken,
//         organization: response.data.organization,
//       });

//       setOrganization(response.data.organization || null);

//       navigate("/dashboard");
//     } catch (error) {
//       const responseMessage =
//         error?.response?.data?.message ||
//         "Unable to login. Please check your credentials and try again.";

//       setErrorMessage(
//         Array.isArray(responseMessage)
//           ? responseMessage.join(", ")
//           : responseMessage,
//       );
//     } finally {
//       setIsSubmitting(false);
//     }
//   };
//   return (
//     <div className="flex font-Outfit items-center justify-center min-h-screen bg-gradient-to-r from-[#0811D4] to-[#04096E]">
//       <div className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md">
//         <div className="flex justify-center mb-6">
//           <img
//             src={Cehr}
//             alt="Logo"
//             className="w-40"
//           />
//         </div>

//         <h2 className="text-2xl font-bold text-center mb-1">Welcome back!</h2>
//         <p className="text-center text-gray-500 mb-6">Login to your account</p>

//         <form onSubmit={handleSubmit}>
//           {errorMessage && (
//             <div
//               className="mb-4"
//               aria-live="polite"
//             >
//               <p
//                 className="text-sm text-red-600 text-center"
//                 role="alert"
//               >
//                 {errorMessage}
//               </p>
//             </div>
//           )}

//           <input
//             type="email"
//             placeholder="Email Address"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             className="w-full px-4 py-3 mb-4 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0811D4] focus:border-transparent"
//           />

//           <div className="relative mb-4">
//             <input
//               type={showPassword ? "text" : "password"}
//               placeholder="Password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0811D4]"
//             />
//             <button
//               type="button"
//               onClick={() => setShowPassword(!showPassword)}
//               className="absolute inset-y-0 right-3 flex items-center text-gray-500"
//             >
//               {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
//             </button>
//           </div>

//           <div className="flex justify-between items-center mb-6">
//             <Link
//               to="#"
//               className="text-sm text-[#0811D4] hover:underline"
//             >
//               Recover Password
//             </Link>
//           </div>

//           <button
//             type="submit"
//             disabled={isSubmitting}
//             className="w-40 mx-auto flex justify-center items-center py-3 rounded-lg bg-[#0811D4] text-white font-medium transition duration-200 hover:bg-[#04096E] disabled:opacity-60 disabled:cursor-not-allowed"
//           >
//             {isSubmitting ? "Logging in..." : "Login"}
//           </button>
//         </form>

//         <p className="text-center text-sm text-gray-500 mt-6">
//           Don’t have an account?{" "}
//           <Link
//             to="/sign-up"
//             className="text-[#0811D4] hover:underline"
//           >
//             Sign Up
//           </Link>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useContext, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { GlobalState } from "../data/Context";
import { setStoredSession } from "../data/authStorage";
import { resolveContractLandingPath, resolveDashboardPath } from "../data/authStorage";
import { getOrganizationSetup } from "../api/organizationSetup";

import HrSoftwareLogin from "../assets/login-workspace-hero.webp";
import CehrBrandmark from "../assets/cehr-brandmark.png";

import {
  UsersRound,
  ChartNoAxesCombined,
  CalendarDays,
  Mail,
  Lock,
  Eye,
  EyeOff,
} from "lucide-react";
import PrimaryButton from "../components/UI/Primary-button";
import { FiLogIn } from "react-icons/fi";

const InputField = ({
  label,
  type,
  placeholder,
  icon: Icon,
  value,
  onChange,
  isPassword,
  showPassword,
  togglePassword,
}) => (
  <div className="w-full text-left">
    <label className="text-sm text-gray-600 mb-1 block">{label}</label>

    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
        <Icon size={18} />
      </span>

      <input
        type={isPassword ? (showPassword ? "text" : "password") : type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="w-full rounded-lg border py-3 pl-10 pr-10 text-base outline-none focus:border-[#1233CC] focus:ring-2 focus:ring-[#00BAFF]/30"
      />

      {isPassword && (
        <button
          type="button"
          onClick={togglePassword}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
        >
          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      )}
    </div>
  </div>
);

const WorkspaceHero = ({ compact = false }) => (
  <div
    className={`relative isolate overflow-hidden text-white ${
      compact
        ? "h-52 w-full rounded-b-[2rem] sm:h-60 lg:hidden"
        : "hidden min-h-[100dvh] w-1/2 flex-col px-8 py-8 xl:px-12 xl:py-10 lg:flex"
    }`}
  >
    <img
      src={HrSoftwareLogin}
      alt="HR colleagues reviewing employee and workforce insights in CephasHR"
      className={`absolute inset-0 -z-20 h-full w-full object-cover ${compact ? "object-[center_42%]" : "object-[center_48%]"}`}
    />
    <div className="absolute inset-0 -z-10 bg-gradient-to-br from-[#071638]/90 via-[#0a2451]/60 to-[#1233CC]/55" />
    <div className={`absolute inset-0 -z-10 ${compact ? "bg-gradient-to-t from-[#06122c]/75 via-transparent to-[#06122c]/30" : "bg-gradient-to-t from-[#06122c]/85 via-transparent to-[#06122c]/40"}`} />

    <div
      className={`relative flex h-full flex-col ${
        compact ? "justify-between px-5 py-4 sm:px-7" : "justify-between"
      }`}
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <img
            src={CehrBrandmark}
            alt=""
            className={`${compact ? "h-9 w-9" : "h-10 w-10"} rounded-xl bg-white object-contain p-1`}
          />
          <span className={`${compact ? "text-lg" : "text-xl"} font-semibold tracking-tight text-white`}>
            CephasHR
          </span>
        </div>
        {!compact && (
          <span className="rounded-full border border-white/25 bg-white/10 px-3 py-1.5 text-xs font-medium tracking-wide text-white/90 backdrop-blur-sm">
            PEOPLE OPERATIONS, SIMPLIFIED
          </span>
        )}
      </div>

      {compact ? (
        <div className="max-w-md">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-cyan-100">
            One workspace. Your people.
          </p>
          <h1 className="mt-1 text-xl font-semibold leading-tight sm:text-2xl">
            Make work better for everyone.
          </h1>
        </div>
      ) : (
        <div className="max-w-xl pb-1">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-cyan-100">
            One workspace. Your people.
          </p>
          <h1 className="max-w-lg text-3xl font-semibold leading-tight xl:text-[2.65rem]">
            A clearer view of your people.
          </h1>
          <p className="mt-3 max-w-lg text-sm leading-6 text-white/80 xl:text-base">
            Bring employee records, payroll, time off and performance together in one thoughtful HR workspace.
          </p>
          <div className="mt-6 grid max-w-xl grid-cols-3 gap-2.5 xl:gap-3">
            {[
              { Icon: UsersRound, label: "Employee records" },
              { Icon: ChartNoAxesCombined, label: "People insights" },
              { Icon: CalendarDays, label: "Time & attendance" },
            ].map(({ Icon, label }) => (
              <div
                key={label}
                className="flex min-h-[68px] items-center gap-2 rounded-xl border border-white/20 bg-white/10 px-2.5 py-3 text-xs font-medium leading-snug text-white shadow-lg shadow-black/10 backdrop-blur-md xl:gap-3 xl:px-3 xl:text-sm"
              >
                <Icon
                  size={18}
                  className="shrink-0 text-cyan-100"
                  aria-hidden="true"
                />
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  </div>
);

const RightPanel = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setOrganization } = useContext(GlobalState);

  const [email, setEmail] = useState(location.state?.email || "");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // ✅ EXACT SAME LOGIC FROM YOUR COMMENTED CODE
  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrorMessage("");

    if (!email.trim() || !password) {
      setErrorMessage("Email and password are required");
      return;
    }

    try {
      setIsSubmitting(true);

      const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || "").replace(
        /\/+$/,
        "",
      );

      if (!apiBaseUrl) {
        throw new Error(
          "API base URL is not configured. Set REACT_APP_API_BASE_URL.",
        );
      }

      const response = await axios.post(
        `${apiBaseUrl}/auth/organization/login`,
        {
          organizationEmail: email.trim(),
          password,
        },
      );

      setStoredSession({
        accessToken: response.data.accessToken,
        refreshToken: response.data.refreshToken,
        organization: response.data.organization,
        loginEmail: email.trim(),
      });

      setOrganization(response.data.organization || null);

      let destination = resolveDashboardPath(response.data.organization);
      if (response.data.staff?.isContractor) {
        destination = resolveContractLandingPath(response.data.staff.modulePermissions || []);
      }
      if (destination === "/dashboard") {
        try {
          const setup = await getOrganizationSetup();
          if (!setup.completed) destination = "/organization-setup";
        } catch (_setupError) {
          // Keep login resilient if setup progress cannot be fetched.
        }
      }
      navigate(destination, {
        replace: true,
      });
    } catch (error) {
      // A missing response means the API was not reached (offline, DNS, CORS,
      // timeout, or the backend is unavailable). Do not present that as bad
      // credentials, since the server never got a chance to validate them.
      const isNetworkFailure = !error?.response;
      const responseMessage = isNetworkFailure
        ? "Unable to connect to the server. Please check your internet connection and try again."
        : error?.response?.data?.message ||
          "Unable to login. Please check your credentials and try again.";

      setErrorMessage(
        Array.isArray(responseMessage)
          ? responseMessage.join(", ")
          : responseMessage,
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-[100dvh] w-full flex-col bg-gray-50 lg:w-1/2 lg:items-center lg:justify-center lg:py-10">
      <WorkspaceHero compact />
      <div className="flex w-full flex-1 items-center justify-center px-4 py-8 sm:px-6 lg:px-10">
        <div className="w-full max-w-md">
        <h2 className="mb-2 text-center text-2xl font-semibold text-gray-900 sm:text-3xl">
          Welcome Back
        </h2>
        <p className="mb-7 text-center text-sm text-gray-500 sm:mb-8 sm:text-base">
          Sign in to your CephasHR account
        </p>

        <form
          onSubmit={handleSubmit}
          className="space-y-5"
        >
          {errorMessage && (
            <p className="text-red-500 text-sm text-center">{errorMessage}</p>
          )}

          <InputField
            label="Email Address"
            type="email"
            placeholder="Enter your email"
            icon={Mail}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <InputField
            label="Password"
            type="password"
            placeholder="Enter your password"
            icon={Lock}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            isPassword
            showPassword={showPassword}
            togglePassword={() => setShowPassword(!showPassword)}
          />

          <div className="flex flex-wrap items-center justify-between gap-3 text-sm">
            <label className="flex items-center gap-2 text-gray-600">
              <input type="checkbox" /> Remember me
            </label>

            <Link
              to="/forgot-password"
              className="text-[#1233CC] hover:underline"
            >
              Forgot password?
            </Link>
          </div>

          {/* <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-gradient-to-r from-[#1233CC] to-[#00BAFF] text-white py-3 rounded-lg shadow-md hover:opacity-90 transition"
          >
            {isSubmitting ? "Logging in..." : "Sign In"}
          </button> */}

          <PrimaryButton
            type="submit"
            isLoading={isSubmitting}
            icon={FiLogIn}
          >
            Sign In
          </PrimaryButton>

          <p className="text-sm text-center mt-4">
            Don’t have an account?{" "}
            <Link
              to="/sign-up"
              className="text-[#1233CC]"
            >
              Sign up here
            </Link>
          </p>
        </form>
        </div>
      </div>
    </div>
  );
};

export default function AuthPage() {
  return (
    <div className="flex min-h-[100dvh] w-full flex-col font-Outfit lg:flex-row">
      <WorkspaceHero />
      <RightPanel />
    </div>
  );
}
